<template>
    <portal
      to="modal"
      :disabled="!isShow"
      :style="{ position: 'absolute' }"
    >
      <ar-modal
        :is-open="isShow"
        class="moshtix-exports-modal"
        header="Connect to Moshtix Exports"
        width="590px"
        :mobile="$arMediaQuery.window.maxWidth('xs')"
        @close="handleCloseClick"
      >
        <div
          slot="body"
          :class="[
            'moshtix-exports-modal-body',
            $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-3',
          ]"
        >
          <ar-field
            label="Account Name"
            class="u-margin-top-5"
              >
              <ar-input
                v-model="accountName"
                name="accountName"
                placeholder="Please enter your Moshtix Exports account name"
                id="moshtix-exports-account-name-input"
                type="text"
                data-test-id="moshtix-exports-account-name-input"
              />
          </ar-field>
          <div
            class="u-display-flex u-margin-top-5"
          >
            <ar-text
              size="xs"
              text="Subscribe associated contacts to list (optional)"
              weight="bold"
              :style="{
                color: $arStyle.color.blueGrey800,
              }"
            />
            <ar-icon
              v-tooltip.top="{
                content: `Automatically subscribe all attendees of events from this account.`,
              }"
              name="tooltip-question-mark"
              class="u-margin-left-2"
              height="15px"
              width="15px"
              :color="$arStyle.color.purple500"
            />
          </div>
          <ar-field
            :error-messages="[
              veeErrors.first('mailingListOid')
            ]"
            :style="{
              marginTop: '15px',
            }"
          >
            <am2-message-list-select
              message-list-type="manual"
              :show-stats="false"
              v-model="mailingListOid"
              :channels="['email']"
            />
          </ar-field>
          <div class="u-display-flex" style="gap: .5rem; align-items: center;">
              <ar-icon
                  :color="$arStyle.color.purple500"
                  name="alert-exclamation-mark"
                  :class="['icon']"
                  class="message-icon"
                  style="width: 16px; "
                />
                <ar-text
                size="xs"
                text="Without selecting a list, contacts imported via this integration can't be identified separately from your other contacts."
                multiple-lines
                :style="{
                  color: $arStyle.color.blueGrey800,
                  marginTop: '.5rem'
                }"
            />
          </div>
        </div>
          
        <div
          slot="footer"
          :class="[
            'moshtix-exports-modal-footer',
            $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-3',
          ]">
          <ar-simple-button
            text="Confirm"
            :loading="loading"
            :disabled="confirmButtonDisabled"
            :style="{ width: '108px' }"
            @click="handleConfirmClick"
            id="moshtix-exports-confirm-button"
            data-test-id="moshtix-exports-confirm-button"
          />
        </div>
      </ar-modal>
    </portal>
  </template>
  
  <script>
  import { mapActions } from 'vuex';
  
  export default {
    name: 'MoshtixExportsModal',
    components: {},
    props: {
      isShow: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        providerName: "",
        accountName: "",
        mailingListOid: null
      };
    },
  
    computed: {
      confirmButtonDisabled() {
        return !this.accountName;
      }
    },
  
    watch: {
      isShow(val) {
        if (val) {
          this.providerName = null;
          this.accountName = null;
          this.mailingListOid = null;
        }
      },
    },
  
    methods: {
      ...mapActions([
        'moshtixExportsIntegration/FETCH_INTEGRATION',
        'moshtixExportsIntegration/CREATE_MOSHTIX_EXPORTS_INTEGRATION',
      ]),
      async fetchIntegration() {
        const success = await this['moshtixExportsIntegration/FETCH_INTEGRATION']()
        return success;
      },
      async handleConfirmClick() {
        this.errorMessage = null;
        this.httpStatus = null;
        const providerName = this.providerName;
        const mailingListOid = this.mailingListOid;
        const accountName = this.accountName;
        const response = await this['moshtixExportsIntegration/CREATE_MOSHTIX_EXPORTS_INTEGRATION']({
          providerName,
          mailingListOid,
          accountName
        });
        if (response) {
          if (this.$route.path != '/settings/integrations/moshtix-exports-new') {
            await this.$router.push({ path: '/settings/integrations/moshtix-exports-new' });;
          }
          else {
            this.fetchIntegration();
          }
          this.$emit('cancel');
        }
        else {
          this.errorMessage = response.message;
          this.httpStatus = response.httpStatusCode;
        }
      },
      handleCloseClick() {
        this.$emit('cancel');
      },
      toggleApplyPrefix() {
        this.applyPrefix = !this.applyPrefix;
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .moshtix-exports-modal {
    .moshtix-exports-modal-body {
      padding: 20px 30px 30px;

      &:nth-child(2) {
        border-top: 1px solid $blueGrey500;
      }
    }
    .moshtix-exports-modal-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 25px 30px;
      height: 100px;
    }
  }
  </style>
  